import React, { useEffect, useRef, useState } from "react";
/** Services Impaort */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import {
  Loading,
  Button,
  Dropdown,
  ButtonGroup,
  Dialog,
  Radio,
} from "../../Components/Bootstrap";
import { Stack, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Icons Import */
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
/** Images Import */
import defaultLine from "../../Assets/Images/MonitoringImages/line_def.png";
import grayLine from "../../Assets/Images/MonitoringImages/line_gray.png";
import greenLine from "../../Assets/Images/MonitoringImages/line_green.png";
import blueLine from "../../Assets/Images/MonitoringImages/line_blue.png";
import orangeLine from "../../Assets/Images/MonitoringImages/line_org.png";
import redLine from "../../Assets/Images/MonitoringImages/line_red.png";
import yellowLine from "../../Assets/Images/MonitoringImages/line_yellow.png";
import leftArrowCircleBlue from "../../Assets/Images/MonitoringImages/next_lft4.png";
import leftArrowStationBlue from "../../Assets/Images/MonitoringImages/next_lft5.png";
import rightArrowCircleBlue from "../../Assets/Images/MonitoringImages/next_rgt4.png";
import rightArrowStationBlue from "../../Assets/Images/MonitoringImages/next_rgt5.png";
import leftArrowCircleRed from "../../Assets/Images/MonitoringImages/pre_lft4.png";
import leftArrowStationRed from "../../Assets/Images/MonitoringImages/pre_lft5.png";
import rightArrowCircleRed from "../../Assets/Images/MonitoringImages/pre_rgt4.png";
import rightArrowStationRed from "../../Assets/Images/MonitoringImages/pre_rgt5.png";
import turn from "../../Assets/Images/MonitoringImages/turn.gif";
import leftBlueBus from "../../Assets/Images/MonitoringImages/bus_def_lft.png";
import leftBlueBusDown from "../../Assets/Images/MonitoringImages/bus_def_lft_down.png";
import leftBlueBus2 from "../../Assets/Images/MonitoringImages/bus_def_lft2.png";
import leftBlueBus3 from "../../Assets/Images/MonitoringImages/bus_def_lft3.png";
import leftBlueBus4 from "../../Assets/Images/MonitoringImages/bus_def_lft4.png";
import leftBlueBus5 from "../../Assets/Images/MonitoringImages/bus_def_lft5.png";
import rightBlueBus from "../../Assets/Images/MonitoringImages/bus_def_rgt.png";
import rightBlueBusDown from "../../Assets/Images/MonitoringImages/bus_def_rgt_down.png";
import rightBlueBus2 from "../../Assets/Images/MonitoringImages/bus_def_rgt2.png";
import rightBlueBus3 from "../../Assets/Images/MonitoringImages/bus_def_rgt3.png";
import rightBlueBus4 from "../../Assets/Images/MonitoringImages/bus_def_rgt4.png";
import rightBlueBus5 from "../../Assets/Images/MonitoringImages/bus_def_rgt5.png";
import leftGreenBus from "../../Assets/Images/MonitoringImages/bus_green_lft.png";
import leftGreenBusDown from "../../Assets/Images/MonitoringImages/bus_green_lft_down.png";
import leftGreenBus2 from "../../Assets/Images/MonitoringImages/bus_green_lft2.png";
import leftGreenBus3 from "../../Assets/Images/MonitoringImages/bus_green_lft3.png";
import leftGreenBus4 from "../../Assets/Images/MonitoringImages/bus_green_lft4.png";
import leftGreenBus5 from "../../Assets/Images/MonitoringImages/bus_green_lft5.png";
import rightGreenBus from "../../Assets/Images/MonitoringImages/bus_green_rgt.png";
import rightGreenBusDown from "../../Assets/Images/MonitoringImages/bus_green_rgt_down.png";
import rightGreenBus2 from "../../Assets/Images/MonitoringImages/bus_green_rgt2.png";
import rightGreenBus3 from "../../Assets/Images/MonitoringImages/bus_green_rgt3.png";
import rightGreenBus4 from "../../Assets/Images/MonitoringImages/bus_green_rgt4.png";
import rightGreenBus5 from "../../Assets/Images/MonitoringImages/bus_green_rgt5.png";
import leftOrangeBus from "../../Assets/Images/MonitoringImages/bus_org_lft.png";
import leftOrangeBusDown from "../../Assets/Images/MonitoringImages/bus_org_lft_down.png";
import leftOrangeBus2 from "../../Assets/Images/MonitoringImages/bus_org_lft2.png";
import leftOrangeBus3 from "../../Assets/Images/MonitoringImages/bus_org_lft3.png";
import leftOrangeBus4 from "../../Assets/Images/MonitoringImages/bus_org_lft4.png";
import leftOrangeBus5 from "../../Assets/Images/MonitoringImages/bus_org_lft5.png";
import rightOrangeBus from "../../Assets/Images/MonitoringImages/bus_org_rgt.png";
import rightOrangeBusDown from "../../Assets/Images/MonitoringImages/bus_org_rgt_down.png";
import rightOrangeBus2 from "../../Assets/Images/MonitoringImages/bus_org_rgt2.png";
import rightOrangeBus3 from "../../Assets/Images/MonitoringImages/bus_org_rgt3.png";
import rightOrangeBus4 from "../../Assets/Images/MonitoringImages/bus_org_rgt4.png";
import rightOrangeBus5 from "../../Assets/Images/MonitoringImages/bus_org_rgt5.png";

function Mornitoring() {
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState("");
  const [reloadTime, setReloadTime] = useState(
    Commons.Storages("get", "saves").reloadTime
  );
  const [busList, setBusList] = useState([]); // 버스 루트 목록 리스트
  const [selectBusValue, setSelectBusValue] = useState(""); // 버스 루트 선택 항목
  const [realTimeList, setRealTimeList] = useState([]);
  const [dividerList, setDividerList] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    const Interval = setInterval(() => {
      if (!reloadTime || reloadTime == "00") {
        return;
      }
      if (selectBusValue) {
        SelectLogic1(selectBusValue);
      }
    }, Number(reloadTime) * 1000);
    return () => clearInterval(Interval);
  }, [selectBusValue]);

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      await IndexedDb.GetLoginInfo().then((result) => setUserInfo(result));
      await SelectLogic();
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 노선 데이터 조회
  const SelectLogic = async () => {
    setLoading(true);
    let _busList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Common.GetCode,
        {
          code: "route",
          key1: "",
          key2: "",
          key3: "",
          key4: "",
        }
      ).then((result) => {
        let data = result.data;
        // console.log("노선 데이터 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _busList.push(data[i]);
          }
          setBusList(_busList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 버스 실시간 조회
  const SelectLogic1 = async (_param1) => {
    setLoading(true);
    let _list = [];
    let _list1 = [];
    let _list2 = [];

    try {
      if (!_param1) {
        throw new Error("버스를 선택해주세요.");
      }

      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminRealTimeBus.AdminRealTimeBus,
        {
          routeId: _param1,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("버스 실시간 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.result.length > 0) {
          // JSON 데이터 파싱
          const parse = JSON.parse(data.result);
          _list = [...parse];

          // 회차지점 기준으로 데이터 분리
          let foundTurn = false;
          _list1 = _list.map((item) => {
            if (item.turnYn === "Y") {
              foundTurn = true;
            }
            return foundTurn ? { ...item, backYn: "Y" } : item;
          });

          // 3개씩 그룹화하여 짝수/홀수 인덱스에 따라 역순 정렬
          _list2 = _list1.reduce((acc, _, index) => {
            if (index % 3 === 0) {
              const group = _list1.slice(index, index + 3);
              acc.push(
                Math.floor(index / 3) % 2 === 1 ? group.reverse() : group
              );
            }
            return acc;
          }, []);
          setRealTimeList(_list);
          setDividerList(_list2);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  const ScrollLogic = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  };

  return (
    <React.Fragment>
      <Card className="mb-2">
        <Card.Body className="horizontal-card-body">
          <Dropdown
            className="me-3"
            variant="outline-primary"
            title="버스를 선택하세요."
            items={busList}
            value={selectBusValue}
            onChange={(e) => {
              setSelectBusValue(e);
              Commons.Storages("set", "saves", {
                ...Commons.Storages("get", "saves"),
                busNo: busList.filter((f) => f.value == e)[0].text,
                routeId: e,
              });
              SelectLogic1(e);
              ScrollLogic();
            }}
          />
          <Button
            size="sm"
            title={
              <FontAwesomeIcon
                icon={faRotateRight}
                onClick={() => SelectLogic1(selectBusValue)}
              />
            }
          />
        </Card.Body>
      </Card>
      <Card className="custom-bus-route-wrap" ref={scrollRef}>
        <Card.Body className="custom-bus-route-body">
          {dividerList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <div
                  className={`custom-bus-route-box ${
                    index == 0 ? "pt-5" : "pt-4"
                  } pb-4`}
                >
                  {item.map((item1, index1) => {
                    const ReturnLine = () => {
                      const speed = Number(item1.speed);
                      const lineProps = {
                        className: "custom-bus-4lines",
                      };

                      if (item.length == 1) {
                        return null;
                      }

                      if (speed < 1) {
                        return <img {...lineProps} src={defaultLine} />;
                      }

                      if (speed >= 30) {
                        return <img {...lineProps} src={greenLine} />;
                      }

                      if (speed >= 20) {
                        return <img {...lineProps} src={yellowLine} />;
                      }

                      if (speed >= 10) {
                        return <img {...lineProps} src={orangeLine} />;
                      }

                      return <img {...lineProps} src={redLine} />;
                    };

                    const ReturnPath = () => {
                      // 홀수 인덱스인지 확인 (1, 3, 5 등)
                      const isOdd = (index + 1) % 2 === 1;
                      // 정류장인지 확인 (pathTp가 2이면 정류장)
                      const isStation = item1.pathTp === "2";
                      // 역방향인지 확인 (backYn이 Y면 역방향)
                      const isBackward = item1.backYn === "Y";
                      // 회전 여부 확인 (turnYn이 Y면 회전)
                      const isTurn = item1.turnYn === "Y";

                      // 화살표 이미지를 결정하는 함수
                      const getArrowImage = () => {
                        if (isTurn) {
                          // 회전이면 turn 이미지 반환
                          return turn;
                        }

                        if (isOdd) {
                          // 홀수 인덱스일 때
                          if (isStation) {
                            // 정류장이면
                            return isBackward // 역방향이면 파란색, 아니면 빨간색 오른쪽 화살표
                              ? rightArrowStationBlue
                              : rightArrowStationRed;
                          }
                          return isBackward // 정류장이 아니면 원형 화살표 사용
                            ? rightArrowCircleBlue
                            : rightArrowCircleRed;
                        } else {
                          // 짝수 인덱스일 때
                          if (isStation) {
                            return isBackward // 역방향이면 파란색, 아니면 빨간색 왼쪽 화살표
                              ? leftArrowStationBlue
                              : leftArrowStationRed;
                          }
                          return isBackward // 정류장이 아니면 원형 화살표 사용
                            ? leftArrowCircleBlue
                            : leftArrowCircleRed;
                        }
                      };

                      // 이미지와 정류장 이름의 CSS 클래스 결정
                      const imageClassName = isTurn
                        ? isOdd
                          ? "custom-bus-turn-left"
                          : "custom-bus-turn-right"
                        : isOdd
                        ? "custom-bus-end-left"
                        : "custom-bus-start-left";
                      const stationClassName = isOdd
                        ? "custom-bus-station-name-right"
                        : "custom-bus-station-name-left";

                      // 화살표 이미지와 정류장 이름을 렌더링
                      return (
                        <React.Fragment>
                          <img
                            className={imageClassName}
                            src={getArrowImage()}
                          />
                          {isStation && ( // 정류장일 경우에만 이름 표시
                            <span className={stationClassName}>
                              {item1.stationNm}
                            </span>
                          )}
                        </React.Fragment>
                      );
                    };

                    const ReturnVerticalLine = () => {
                      // 홀수/짝수 및 라인 위치 확인
                      const isOdd = (index + 1) % 2 === 1;
                      const isRightLine = isOdd && index1 === 2;
                      const isLeftLine = !isOdd && index1 === 0;
                      const isLastItem = index === dividerList.length - 1;

                      // 속도에 따른 색상 결정
                      const speed = Number(item1.speed);
                      const getLineColor = (speed) => {
                        if (speed >= 30) return "#00A038";
                        if (speed >= 20) return "#DFB300";
                        if (speed >= 10) return "#F16804";
                        if (speed >= 1) return "#C70C0C";
                        return "#BCBCBC";
                      };
                      const color = getLineColor(speed);

                      // 마지막 아이템이면 null 반환
                      if (isLastItem) return null;

                      // 오른쪽/왼쪽 라인에 따라 컴포넌트 반환
                      const lineClass = isRightLine
                        ? "custom-bus-vertical-line-right"
                        : isLeftLine
                        ? "custom-bus-vertical-line-left"
                        : null;

                      return (
                        lineClass && (
                          <div
                            className={lineClass}
                            style={{ backgroundColor: color }}
                          />
                        )
                      );
                    };

                    const ReturnBus = () => {
                      // 홀수/짝수 여부 확인
                      const isOdd = (index + 1) % 2 === 1;
                      // 버스 존재 여부 확인
                      const hasBus = item1.vhcleNo !== "-";

                      // 버스가 없으면 null 반환
                      if (!hasBus) return null;

                      // 버스 이미지와 클래스 설정
                      const getBusProps = () => {
                        const className = isOdd
                          ? "custom-bus-station-arrival"
                          : "custom-bus-station-moving";

                        switch (item1.color) {
                          case "WHITE":
                            return {
                              className,
                              src: isOdd ? rightBlueBus : leftBlueBus,
                            };
                          case "#FF7E7E":
                            return {
                              className,
                              src: isOdd ? rightOrangeBus : leftOrangeBus,
                            };
                          case "#74D36D":
                            return {
                              className,
                              src: isOdd ? rightGreenBus : leftGreenBus,
                            };
                          default:
                            return {};
                        }
                      };

                      // 말풍선 속성 설정
                      const balloonProps = {
                        className: isOdd
                          ? "custom-bus-ballon-arrival"
                          : "custom-bus-ballon-moving",
                        style: { backgroundColor: item1.color },
                      };

                      return (
                        <React.Fragment>
                          <img {...getBusProps()} />
                          <div {...balloonProps}>
                            <p className="custom-bus-ballon-car-no">
                              {item1.vhcleNo}
                            </p>
                            <p className="custom-bus-ballon-minute">{`${item1.intv}분`}</p>
                          </div>
                        </React.Fragment>
                      );
                    };

                    return (
                      <React.Fragment key={index1}>
                        <div className="custom-bus-route-box-line">
                          {ReturnLine()}
                          {ReturnPath()}
                          {ReturnVerticalLine()}
                          {ReturnBus()}
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </React.Fragment>
            );
          })}
        </Card.Body>
      </Card>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default Mornitoring;
